import { useApi } from '@repo-level/core-front';
import type { ICMSHeadlinePromo } from 'api/cms/headlinePromo';
import { headlinePromo } from 'api/cms/headlinePromo';
import type { FC } from 'react';
import { createContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IHeadlinePromoContext {
  headlinePromoData: ICMSHeadlinePromo | null;
  headlinePromoPending: boolean;
}

export const HeadlinePromoContext = createContext<IHeadlinePromoContext>({
  headlinePromoData: null,
  headlinePromoPending: false,
});

export const HeadlinePromoContextProvider: FC = ({ children }) => {
  const {
    i18n: { language },
  } = useTranslation();

  const [requestHeadlinePromo, { data, pending }] = useApi(headlinePromo);

  useEffect(() => {
    requestHeadlinePromo(language);
  }, [language, requestHeadlinePromo]);

  const contextValue = useMemo(
    () => ({
      headlinePromoData: data ?? null,
      headlinePromoPending: pending,
    }),
    [data, pending]
  );

  return (
    <HeadlinePromoContext.Provider value={contextValue}>
      {children}
    </HeadlinePromoContext.Provider>
  );
};
